module.exports = __webpack_public_path__ + "static/media/no-connection.0714262b.png";